var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { useSaveSearchHistoryMutation, useSearchBasicModulesQuery, } from "@/store/api";
import { faSearch, faSquare, } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ChipDelete, Chip, Input, } from "@mui/joy";
import { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Preview from "@/components/widgets/list/preview";
import { createPortal } from "react-dom";
import { IconMappingModule } from "@/components/widgets/default/menu/iconCorrespondance";
import { useAppSelector } from "@/hooks/store";
import moment from "moment";
import "moment/locale/fr";
import History from "./history";
import { useColorIcons } from "@/utils/themes/hooks";
import { useTranslation } from "react-i18next";
moment.locale("fr");
export default function WidgetSearch(_a) {
    var _this = this;
    var _b;
    var widget = _a.widget;
    var t = useTranslation(["common"]).t;
    var _c = useState(""), inputValue = _c[0], setInputValue = _c[1];
    var _d = useState(false), noResults = _d[0], setNoResults = _d[1];
    var _e = useState([]), chips = _e[0], setChips = _e[1];
    var _f = useState([]), recentSearch = _f[0], setRecentSearch = _f[1];
    var navigate = useNavigate();
    var inputRef = useRef(null);
    var dropdownRef = useRef(null);
    var _g = useState(false), isNextClicked = _g[0], setIsNextClicked = _g[1];
    var _h = useState({ top: 0, left: 0 }), dropdownPosition = _h[0], setDropdownPosition = _h[1];
    var _j = useState(false), isHovering = _j[0], setIsHovering = _j[1];
    var _k = useState(false), clicked = _k[0], setClicked = _k[1];
    var searchQuery = useMemo(function () {
        return inputValue
            .split(" ")
            .filter(function (word) { return !word.startsWith("module:"); })
            .join(" ");
    }, [inputValue]);
    var _l = useSearchBasicModulesQuery({ params: { query_string: searchQuery } }, { skip: !searchQuery.trim() }), searchBasicModules = _l.data, isLoading = _l.isLoading, isFetching = _l.isFetching, refetch = _l.refetch;
    var _m = useSaveSearchHistoryMutation(), saveSearchHistory = _m[0], resultSearchHistory = _m[1].data;
    var options = useMemo(function () {
        var _a, _b;
        var results = ((_b = (_a = searchBasicModules === null || searchBasicModules === void 0 ? void 0 : searchBasicModules.data) === null || _a === void 0 ? void 0 : _a.results) === null || _b === void 0 ? void 0 : _b.hits.map(function (element) { return ({
            id: element.record_id,
            name: element.name,
            module: element.record_module,
            fields: element.fields,
            score: element.score,
        }); })) || [];
        if (chips.length > 0) {
            results = results.filter(function (option) { return chips.includes(option.module); });
        }
        return results;
    }, [searchBasicModules === null || searchBasicModules === void 0 ? void 0 : searchBasicModules.data, chips]);
    useEffect(function () {
        setNoResults(options.length === 0 && searchQuery.trim().length > 0);
    }, [options, searchQuery]);
    useEffect(function () {
        if (searchQuery.trim().length > 0) {
            refetch();
        }
    }, [searchQuery, refetch]);
    var handleKeyDown = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var modules_1;
        return __generator(this, function (_a) {
            if (e.key === "Enter" && inputValue.trim() !== "") {
                modules_1 = inputValue
                    .split(" ")
                    .filter(function (word) { return word.startsWith("module:"); })
                    .map(function (word) { return word.replace("module:", ""); });
                setChips(function (prevChips) {
                    var newModules = modules_1.filter(function (module) { return !prevChips.includes(module); });
                    return __spreadArray(__spreadArray([], prevChips, true), newModules, true);
                });
                setInputValue(searchQuery);
            }
            return [2 /*return*/];
        });
    }); };
    var handleDeleteChip = function (chipToDelete) {
        setChips(function (prev) { return prev.filter(function (chip) { return chip !== chipToDelete; }); });
    };
    useEffect(function () {
        if (inputRef.current) {
            var rect = inputRef.current.getBoundingClientRect();
            setDropdownPosition({ top: rect.bottom + 5, left: rect.left });
        }
    }, [isHovering, inputValue]);
    var handleClick = function (value) {
        setClicked(value);
        setIsHovering(false);
    };
    useEffect(function () {
        function handleClickOutside(event) {
            var _a;
            if (dropdownRef.current &&
                !dropdownRef.current.contains(event.target) &&
                !((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
                if (chips.length > 0 && inputValue) {
                    handleSaveSearchHistory();
                }
                setIsHovering(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [chips]);
    var colorIcons = useColorIcons();
    var handleSaveSearchHistory = function () { return __awaiter(_this, void 0, void 0, function () {
        var response;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!chips)
                        return [2 /*return*/];
                    return [4 /*yield*/, saveSearchHistory({
                            body: {
                                term: searchQuery,
                                modules: chips,
                                dateCreated: moment().format("YYYY-MM-DD HH:mm:ss"),
                            },
                        }).unwrap()];
                case 1:
                    response = _c.sent();
                    if ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.recent_searches) {
                        setRecentSearch((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.recent_searches);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var isInHeader = (_b = widget === null || widget === void 0 ? void 0 : widget.slot) === null || _b === void 0 ? void 0 : _b.includes("HEADER");
    var editingLayout = useAppSelector(function (state) { return state.layout.editingLayout; });
    var widgetDefinition = widgetsDictionary.get(widget.type);
    var inEditMode = editingLayout &&
        ((widgetDefinition === null || widgetDefinition === void 0 ? void 0 : widgetDefinition.editable) === undefined || (widgetDefinition === null || widgetDefinition === void 0 ? void 0 : widgetDefinition.editable));
    return (_jsxs("div", __assign({ className: "p-2 px-5 w-full !z-50 " }, { children: [!isHovering && (_jsx(FontAwesomeIcon, { onMouseEnter: function () {
                    !inEditMode && setIsHovering(true);
                }, icon: faSearch, size: "lg" })), isHovering && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "flex min-w-0" }, { children: _jsx(Input, { autoFocus: true, 
                            // onBlur={() => searchQuery === "" && setIsHovering(false)}
                            type: "text", ref: inputRef, className: "w-full h-full", 
                            //className="w-60"
                            value: inputValue, onChange: function (e) { return setInputValue(e.target.value); }, placeholder: "".concat(t("app.LBL_SEARCH", { ns: "common" }), "..."), endDecorator: _jsx(FontAwesomeIcon, { icon: faSearch, className: "cursor-pointer hover:text-[--colors-link] rounded", onClick: function () {
                                    navigate("/modules/Home/UnifiedSearch/".concat(searchQuery));
                                } }), onKeyDown: handleKeyDown }) })), recentSearch &&
                        createPortal(_jsx("div", __assign({ ref: dropdownRef }, { children: _jsxs("ul", __assign({ className: "shadow-md ".concat(isInHeader ? " w-[350px]" : "w-[240px]", " mt-1 rounded-md"), style: {
                                    border: "1px solid var(--colors-body-bg-sec)",
                                    padding: 0,
                                    background: "var(--colors-bg-default)",
                                    position: "absolute",
                                    top: "".concat(dropdownPosition.top, "px"),
                                    left: "".concat(dropdownPosition.left, "px"),
                                    right: "auto",
                                    //height: `${options?.length < 5 ? "345px" : "600px"}`,
                                    height: "auto",
                                    overflowY: "auto",
                                    overflowX: "auto",
                                    zIndex: 9999,
                                } }, { children: [_jsxs("li", __assign({ className: " pb-2 px-1 mb-4 mt-2 border-b space-x-1" }, { children: [searchQuery && (_jsxs(Chip, __assign({ size: "sm", variant: "outlined", color: "neutral", sx: {
                                                    backgroundColor: "#D3D3D340",
                                                }, endDecorator: _jsx(ChipDelete, { onDelete: function () { return setInputValue(""); }, sx: {
                                                        backgroundColor: "#D3D3D380",
                                                    } }) }, { children: ["\"", searchQuery, "\""] }))), chips === null || chips === void 0 ? void 0 : chips.map(function (module, index) { return (_jsx(Chip, __assign({ size: "sm", variant: "outlined", color: "neutral", sx: {
                                                    border: "1px solid ".concat(colorIcons && colorIcons[module], " "),
                                                    color: "".concat(colorIcons && colorIcons[module]),
                                                    backgroundColor: "".concat(colorIcons && colorIcons[module], "10"),
                                                }, endDecorator: _jsx(ChipDelete, { onDelete: function () { return handleDeleteChip(module); }, sx: {
                                                        color: "".concat(colorIcons && colorIcons[module], " !important"),
                                                        backgroundColor: "".concat(colorIcons && colorIcons[module], "60"),
                                                    } }) }, { children: module }), index)); })] })), isLoading || isFetching ? (_jsx("li", __assign({ className: "p-2 text-sm text-[--colors-label]" }, { children: t("app.LBL_LOADING", { ns: "common" }) }))) : noResults && !isLoading ? (_jsx("li", __assign({ className: "p-2 text-sm text-[--colors-label]" }, { children: t("app.LBL_NO_RESULTS") }))) : !inputValue ? (_jsx("li", __assign({ className: "p-2 text-sm italic text-[--colors-label] opacity-50 " }, { children: t("app.LBL_SEARCH_RESULT") }))) : (options.slice(0, 10).map(function (option) {
                                        var _a, _b;
                                        return (_jsxs("li", __assign({ className: "flex h-[1.7rem] justify-between text-sm items-center px-3 py-0.5 mt-2 text-[var(--colors-label)]" }, { children: [_jsxs("span", __assign({ className: "flex cursor-pointer hover:text-[var(--colors-link)] hover:bg-gray-50 text-xs items-center", onClick: function (event) {
                                                        event.stopPropagation();
                                                        navigate("/modules/".concat(option.module, "/DetailView/").concat(option.id));
                                                    } }, { children: [_jsx(FontAwesomeIcon, { className: "text-[25px] mr-1", color: colorIcons ? colorIcons[option.module] : "", icon: IconMappingModule[option.module]
                                                                ? IconMappingModule[option.module]
                                                                : faSquare }), _jsx("span", __assign({ className: "truncate ".concat(isInHeader ? "w-[150px]" : "w-[90px]", " ") }, { children: option.name }))] })), _jsxs("span", __assign({ className: "flex items-center gap-2" }, { children: [_jsx("span", __assign({ onClick: function (event) {
                                                                event.stopPropagation();
                                                            }, className: "cursor-pointer hover:text-blue-600" }, { children: _jsx(Preview, { record: option.fields, module: option.module || "", handleClick: handleClick, className: "text-xs" }) })), _jsxs("span", __assign({ className: "font-bold text-[11px]" }, { children: ["SCORE: ", (_b = (_a = option.score) === null || _a === void 0 ? void 0 : _a.toFixed(2)) !== null && _b !== void 0 ? _b : "N/A"] }))] }))] }), option.id));
                                    })), inputValue &&
                                        !isFetching &&
                                        !isLoading &&
                                        (options === null || options === void 0 ? void 0 : options.length) >= 10 && (_jsx("li", __assign({ className: "flex justify-end w-full px-2" }, { children: _jsx("a", __assign({ onClick: function () {
                                                navigate("/modules/Home/UnifiedSearch/".concat(searchQuery));
                                                setIsHovering(false);
                                            }, className: "text-[--colors-link] hover:text-[--colors-link] text-sm cursor-pointer" }, { children: t("app.LBL_SHOW_MORE") })) }), "voir-plus")), _jsx(History, { dataRecentSearch: recentSearch, setInputValue: setInputValue, setChips: setChips })] })) })), document.body)] }))] })));
}
widgetsDictionary.register("widget/search", {
    name: "Widget Search",
    display: WidgetSearch,
});
